import { Injectable } from '@angular/core';

import * as SecureLS from 'secure-ls';
import { CandidateModel } from '../model/candidate';

@Injectable()
export class AppService {
  private ls;
  constructor() {
    this.ls = new SecureLS({ encodingType: "rc4", isCompression: true });
  }


  setCandidatesSessionObj(candidates): void {

    this.ls.set('candidates', { data: JSON.stringify(candidates) });
  }

  getCandidatesSessionObj(): Array<CandidateModel> {
    let candidates = this.ls.get("candidates");
    if (candidates !== "") {
      let candidateObj = JSON.parse(candidates.data);
      return candidateObj;
    }
    return [];
  }


  clearAll() {
    this.ls.removeAll();
  }

}



// WEBPACK FOOTER //
// ./src/app/service/app.service.ts